function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49.782mm",
    height: "57.191mm",
    viewBox: "0 0 49.782 57.191",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.243 -56.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.267 113.35c-4.8032-1.3723-8.7825-10.274-8.508-14.391 0.1278-1.917 0.78034-10.386-2.6505-15.189-2.1856-3.0598-3.8641-7.8968-3.8649-12.692v42.272z",
    style: {
      strokeLinecap: "round",
      strokeWidth: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.025 69.736c-0.0031 4.849-1.6156 11.232-4.0199 14.598-3.4308 4.8032-2.4977 12.711-2.3699 14.628 0.27447 4.117-3.3519 13.217-8.8827 14.391-1.5603-0.2059-6.9749-2.6931-7.4409-9.1772-0.12332-3.9544-1.0714-6.6451-1.9275-6.7112-1.7736-0.06615-2.4789 6.8828-2.4789 6.8828-0.99076 8.2014-5.0867 8.9827-7.6388 9.0062h34.759z",
    style: {
      strokeLinecap: "round",
      strokeWidth: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.02 56.162c1.4613 2.3e-4 2.8141 0.23863 3.437 0.4532 3.8448 1.3244 5.9568 3.3417 8.6284 8.1023 0.64642 1.1519 0.9387 2.9322 0.93999 4.9909v-13.546z",
    style: {
      strokeLinecap: "round",
      strokeWidth: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.243 56.162v14.912c4.43e-4 -2.7296 0.54481-5.4455 1.849-7.8114 2.1406-3.8832 8.5439-9.1466 15.268-6.2647 6.6532 2.8514 7.5551 2.0784 7.5551 2.0784s2.8561-0.15746 9.0005-2.4427c0.83554-0.31076 1.8133-0.44319 2.7657-0.46767 0.1117-0.0029 0.2231-0.0041 0.33383-0.0041z",
    style: {
      strokeLinecap: "round",
      strokeWidth: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.016 56.162c-0.11073 1.7e-5 -0.22213 0.0013-0.33383 0.0041-0.95242 0.02448-1.9302 0.15691-2.7657 0.46767-6.1444 2.2853-9.0005 2.4427-9.0005 2.4427s-0.90186 0.77296-7.5551-2.0784c-6.7244-2.8819-13.128 2.3815-15.268 6.2647-3.5962 6.5237-1.4149 15.707 2.0159 20.51 3.4308 4.8032 2.7783 13.272 2.6505 15.189-0.27446 4.117 3.7049 13.019 8.508 14.391 2.5521-0.0235 6.648-0.80482 7.6388-9.0062 0 0 0.70527-6.9489 2.4789-6.8828 0.85611 0.06615 1.8042 2.7568 1.9275 6.7112 0.46599 6.4841 5.8806 8.9713 7.4409 9.1772 5.5308-1.1739 9.1571-10.274 8.8827-14.391-0.1278-1.917-1.061-9.8249 2.3699-14.628 3.4308-4.8032 5.2499-15.749 3.0799-19.616-2.6716-4.7607-4.7836-6.7779-8.6284-8.1023-0.62352-0.21478-1.9783-0.45343-3.4411-0.4532zm0.06925 4.4865c3.8063 0.16649 6.5838 3.1228 7.6574 5.8069 1.4095 3.5237-0.47011 12.803-3.4065 16.914-2.9364 4.1109-2.4581 11.279-2.3487 12.92 0.23491 3.5237-1.4096 11.863-5.5206 13.037-1.76-0.31776-3.2354-9.0619-3.4065-10.336-0.10555-3.3845-0.71756-6.2244-4.932-6.2244-3.4429 0-4.933 6.2255-4.933 6.2255-0.45169 1.4147-1.845 10.316-3.4065 10.336-4.1109-1.1746-5.7555-9.5138-5.5206-13.037 0.10938-1.6407 0.5877-8.8092-2.3487-12.92-2.9364-4.1109-4.816-13.39-3.4065-16.914 1.4095-3.5237 5.7556-7.5169 11.511-5.0503 5.6944 2.4405 8.0541 2.3514 8.1034 2.3492v-1e-3s2.3491 0.11787 8.1044-2.3487c1.0791-0.46248 2.1089-0.69795 3.0789-0.75189 0.2627-0.01461 0.52088-0.0157 0.77463-0.0047z",
    style: {
      fill: "#fff",
      paintOrder: "markers fill stroke",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeWidth: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/tooth.1d0426336d3443af8525e5ea74367ade.svg";
export { ForwardRef as ReactComponent };